import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'store/hook';
import { handleSetSelectedCommunity, handleSetSelectedParentCommunity } from 'store/slices/globalSlice';

import CommunityAiCompetitiveIntelligence from './CommunityAiCompetitiveIntelligence';
import CompanyAiCompetitiveIntelligence from './CompanyAiCompetitiveIntelligence';

const Recommendations = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const communityIdParam = searchParams.get('communityId');

  const { selectedCompany, selectedCommunity } = useAppSelector((state) => state.global);
  const { currentUser } = useAppSelector((state) => state.auth);

  const isCommunity = Boolean(communityIdParam);
  const isCompany = !communityIdParam && (Boolean(selectedCompany) || Boolean(currentUser?.holding));

  useEffect(() => {
    if (isCompany && selectedCommunity) {
      dispatch(handleSetSelectedCommunity(undefined));
      dispatch(handleSetSelectedParentCommunity(undefined));
    }
  }, [dispatch, isCompany, selectedCommunity]);

  return (
    <>
      {isCommunity && <CommunityAiCompetitiveIntelligence />}
      {isCompany && <CompanyAiCompetitiveIntelligence />}
    </>
  );
};

export default Recommendations;
